<template>
  <div ref="target">
    <slot />
  </div>
</template>

<script setup lang="ts">
  interface IProps {
    offset?: number;
  }

  const props = withDefaults(defineProps<IProps>(), { offset: 0 });

  const emits = defineEmits<{ (e: 'trigger'): void }>();

  const { y } = useScrollValue();

  const target = ref<HTMLElement | null>(null);

  watch(
    y,
    (value) => {
      if (target.value) {
        if (value >= target.value.offsetTop - props.offset) {
          emits('trigger');
        }
      }
    },
    { immediate: true }
  );
</script>
